// src/App.jsx
import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import FeaturedPrizes from '../components/FeaturedPrizes';
import HowItWorks from '../components/HowItsWork';
import LiveWinners from '../components/LiveWinners';
import CurrentCampaigns from '../components/CurrentCampaigns';
import TicketPurchase from '../components/TicketsPurchase';
import Testimonials from '../components/Testimonials';
import Footer from '../components/Footer';
import UpCommingCampaigns from './UpCommingCampaigns';
import CompletedCampaigns from './CompletyedCampaigns';

function Home() {
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setTimeout(() => setIsLoading(false), 1000);
  }, []);

  return (
    <AnimatePresence>
      {isLoading ? (
        <motion.div
          key="loader"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 flex items-center justify-center bg-gray-900 z-50"
        >
          <div className="relative">
            <div className="w-24 h-24 border-4 border-purple-500/30 border-t-purple-500 rounded-full animate-spin"></div>
            <div className="absolute inset-0 flex items-center justify-center">
              <span className="text-3xl">🎰</span>
            </div>
          </div>
        </motion.div>
      ) : (
        <motion.div
          key="content"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
          className="min-h-screen"
        >
          <Navbar />
          <main>
            <Hero />

            <section id="campaigns">
              {/* <UpCommingCampaigns /> */}
              <CurrentCampaigns />
              <CompletedCampaigns />
            </section>

            <section id="how-it-works">
              <HowItWorks />
            </section>

            <section id="winners">
              <LiveWinners />
            </section>

            <section id="testimonials">
              <Testimonials />
            </section>
          </main>
          <Footer />
        </motion.div>
      )}
    </AnimatePresence>
  );
}

export default Home;